import { forwardRef, type PropsWithChildren } from 'react';
import { css, styled } from 'styled-components';

import { getMediaQuery } from '~/utils/responsive/media';

import { MainContainer } from './mainContainer';

export type IframeContainerProps = {
  removeTopMargin?: boolean;
};

export const StyledIframeContainer = styled.div<IframeContainerProps>`
  box-sizing: border-box;
  width: 100%;
  max-width: ${({ theme }) => theme.sizes?.maxBodyWidth};
  padding: 1rem;
  ${({ removeTopMargin }) =>
    removeTopMargin
      ? css`
          margin: -8rem auto 0 auto;
        `
      : css`
          margin: 0 auto;
        `};
  position: relative;

  ${getMediaQuery('tablet')} {
    ${({ removeTopMargin }) =>
      !removeTopMargin &&
      css`
        padding: 3rem 4rem;
      `};
  }

  ${getMediaQuery('mobile')} {
    ${({ removeTopMargin }) =>
      !removeTopMargin
        ? css`
            padding: 1rem;
          `
        : css`
            margin: -6rem auto 0 auto;
          `};
  }
`;

export const IframeContainer = forwardRef<HTMLDivElement, PropsWithChildren<IframeContainerProps>>(
  ({ children, ...props }, ref) => (
    <MainContainer ref={ref} {...props}>
      <StyledIframeContainer>{children}</StyledIframeContainer>
    </MainContainer>
  ),
);
